module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "oauth-callback"
  }, [(_vm.loading) ? _c('div', [_c('p', [_vm._v("驗證中，請稍候...")])]) : (_vm.error) ? _c('div', {
    staticStyle: {
      "color": "red"
    }
  }, [_c('p', [_vm._v("發生錯誤：" + _vm._s(_vm.error))]), _vm._v(" "), _c('p', [_vm._v("將在 " + _vm._s(_vm.countdown) + " 秒後返回登入頁面")])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55b448bc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/OAuthCallback.vue
// module id = 924
// module chunks = 170